export default "__VITE_ASSET__d2ecd074__"